import PageComponent from '../base/PageComponent';

export default class Navigation extends PageComponent {
    init() {
        if (this.shouldSticky()) {
            this.sticky();
            this.listen();
        }
    }

    /**
     * Tests if the content is shorter than window height,
     * if so, then we want the footer to go to the bottom of the screen
     */
    shouldSticky() {
        let bodyHeight = $('body').height(),
            windowHeight = $(window).height(),
            footerHeight = this.element.height();

        return bodyHeight < windowHeight;
    }

    /**
     * Sticky footer by adding sticky class
     */
    sticky() {
        this.element.addClass('sticky');
    }

    /**
     * Unsticky footer by removing sticky class
     */
    unsticky() {
        this.element.removeClass('sticky');
    }

    /**
     * Listen to window resize to unsticky/sticky
     */
    listen() {
        $(window).on('resize', _.debounce(() => {
            if (!this.shouldSticky()) {
                this.unsticky();
            } else {
                this.sticky();
            }
        }, 100));
    }
}


// WEBPACK FOOTER //
// ./javascript/components/Footer.js